export const InformationSharpSolid = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.73,16.29l-.02-6.43h-2.86s0,1.44,0,1.44h1.43s.01,5,.01,5h-2.14s0,1.44,0,1.44l5.72-.02v-1.43s-2.14,0-2.14,0h-.01Zm-.74-10.72c-.59,0-1.07,.48-1.07,1.07s.48,1.07,1.07,1.07,1.07-.48,1.07-1.07c-.01-.59-.49-1.06-1.07-1.07Zm.04,16.44c-5.53,.01-10.02-4.45-10.04-9.98S6.44,2,11.97,1.99s10.02,4.45,10.04,9.98c0,5.52-4.46,10-9.98,10.04h.01Z" />
    </svg>
  );
};
